export enum PUB_SUB_TOPICS {
    AUTH = 'AUTH',
    SYSTEM = 'SYSTEM',
    OUTDATED = 'OUTDATED',
}
